export class SuperComponent {

    mobileMenuOpen: boolean = false;

    constructor() {
    }

    getMobileOpenNotification(mobileMenuOpen: boolean) {
        this.mobileMenuOpen = mobileMenuOpen;
    }

}
